import React, { useRef } from "react";
import { Stack, Typography } from "@mui/material";

import { shiftLight } from "../../helpers/color";
import { HubIcon, PriorityLabel } from "../../components";

import ScheduleTableContextMenu from "./ScheduleTableContextMenu";
import { StyledBox, StyledTagBox } from "./styles";
import { useGanttDragHandler } from "./useDragHelper";

const ScheduleTableBox = ({
  darkMode,
  backgroundColor,
  span,
  color,
  wo,
  guideRef,
  setIndex = () => {},
  setIsDragging = () => {},
  disabled = false,
}) => {
  const boxRef = useRef(null);

  useGanttDragHandler({
    boxRef,
    guideRef,
    wo,
    setIndex,
    setIsDragging,
    disabled,
  });

  const fontColor = shiftLight(color, darkMode ? 0.8 : 0.4);

  const backgroundColor2 = shiftLight(color, darkMode ? 0.25 : 0.89);
  const backgroundColor1 = shiftLight(color, darkMode ? 0.15 : 0.95);
  const percent = wo?.percent;

  return (
    <Stack
      position="relative"
      ref={boxRef}
      sx={{
        width: `calc(${span} * 45px)`,
        left: "23px",
        transition: "left 0.05s ease-in-out",
      }}
    >
      <HubIcon
        icon="ArrowLeft"
        size="12px"
        className="GanttBox-Arrows"
        sx={{
          position: "absolute",
          top: 0,
          bottom: 0,
          left: "-17px",
          margin: "auto",
          display: "none",
        }}
      />
      <StyledBox
        backgroundColor={backgroundColor}
        backgroundColor1={backgroundColor1}
        backgroundColor2={backgroundColor2}
        percent={percent}
        span={span}
        {...(percent > 0 && { started: "true" })}
      >
        <StyledTagBox color={color}>
          <ScheduleTableContextMenu id={wo.id} workOrder={wo.workOrder} />
        </StyledTagBox>
        <PriorityLabel priority={wo.priority} iconOnly />
        <Typography
          variant="caption"
          sx={{ fontWeight: 600, color: fontColor }}
        >
          {wo.partName} - {wo.workOrder}
        </Typography>
      </StyledBox>
      <HubIcon
        icon="ArrowRight"
        size="12px"
        className="GanttBox-Arrows"
        sx={{
          position: "absolute",
          top: 0,
          bottom: 0,
          right: "-17px",
          margin: "auto",
          display: "none",
        }}
      />
    </Stack>
  );
};

export default ScheduleTableBox;
